import { h } from 'preact'

import { useEffect } from 'preact/hooks'

import { isMobile } from '@utils/ua'

import { clearAllBodyScrollLocks, disableBodyScroll } from './util'

import { preventDefault } from './util'

export default function LockBodyScroll({
  shouldLockScroll,
  allowScrollElementClassLists = [],
}) {
  const handleGestureStart = (e) => {
    e.preventDefault()
  }

  const lockScroll = () => {
    if (isMobile) {
      allowScrollElementClassLists.forEach((className) => {
        disableBodyScroll(document.querySelector(`.${className}`))
      })

      document.addEventListener('touchmove', preventDefault, { passive: false })
    }

    document.addEventListener('gesturestart', handleGestureStart)
    document.documentElement.classList.add('lock-scroll')
  }

  const releaseScroll = () => {
    if (isMobile) {
      clearAllBodyScrollLocks()
      document.removeEventListener('touchmove', preventDefault, {
        passive: false,
      })
    }

    document.removeEventListener('gesturestart', handleGestureStart)
    document.documentElement.classList.remove('lock-scroll')
  }

  useEffect(() => {
    if (shouldLockScroll) {
      lockScroll()
    } else {
      releaseScroll()
    }

    return () => {
      document.removeEventListener('gesturestart', handleGestureStart)
    }
  }, [shouldLockScroll])

  if (!shouldLockScroll) {
    return null
  }

  return (
    <style>{`
      html.lock-scroll,
      html.lock-scroll body {
        overflow: hidden;
        touch-action: none;
        -webkit-overflow-scrolling: none;
        overscroll-behavior: none;
      }
    `}</style>
  )
}
